// Academy API-Client. V3-Routen (Worker `api/src/routes/academy.ts`, auth-gated):
// - GET  /academy/progress          → AcademyProgress[]
// - POST /academy/progress          → { ok: true }
//
// Pattern identisch zu `eve-memory-api.ts`: shared `apiFetch` aus `./api`,
// Bearer-Auth via `accessToken`-Parameter.

import { apiFetch } from './api';

/** Eine Fortschritts-Zeile pro Academy-Modul (D1-Row-Shape, 1:1 vom Worker). */
export interface AcademyProgress {
  module_id: string;
  read_at: string | null;
  /** 0/1 als SQLite-Boolean. */
  quiz_passed: number;
  quiz_score: number | null;
}

export async function fetchAcademyProgress(accessToken: string): Promise<AcademyProgress[]> {
  return apiFetch<AcademyProgress[]>('/academy/progress', { accessToken });
}

export interface PostAcademyProgressInput {
  moduleId: string;
  read?: boolean;
  quizPassed?: boolean;
  quizScore?: number;
}

export async function postAcademyProgress(
  input: PostAcademyProgressInput,
  accessToken: string,
): Promise<void> {
  await apiFetch('/academy/progress', {
    method: 'POST',
    accessToken,
    json: input,
  });
}
